import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import useMedia from '../../hooks/useMedia';
import CardCircle from './CardCircle';

interface Props {
  title: string;
  iconOn?: boolean;
  iconColor?: string;
  iconCenter?: boolean;
  textColor?: string;
  bgcolor?: string;
  iconName?: string;
}

const CardHeader: FC<Props> = observer(props => {
  const { title, iconCenter, iconOn, iconColor, bgcolor, iconName } = props;
  const isMobile = useMedia('md');

  const iconSize = isMobile ? 50 : 80;

  const white = bgcolor || 'background.paper';

  const debug = false;

  return (
    <Box width={1} display="flex" bgcolor={debug ? 'green' : ''}>
      {iconOn && (
        <Box
          width={iconCenter ? 1 : 160}
          display="flex"
          justifyContent={iconCenter ? 'flex-end' : 'flex-start'}
          bgcolor={debug ? 'lightgreen' : ''}
        >
          <Box width={1} height={1} display="flex">
            <Box
              height={0.5}
              width={0.5}
              bgcolor={debug ? 'lightcyan' : white}
            />
            <Box
              height={isMobile ? 0.534 : 0.5}
              width={0.5}
              bgcolor={debug ? 'lightsteelblue' : white}
            >
              <CardCircle
                iconColor={iconColor || 'primary.main'}
                iconSize={iconSize}
                iconName={iconName}
                customStyle={{
                  sx: {
                    transform: `translateX(-${iconSize / 2}px)`,
                  },
                }}
              />
            </Box>
          </Box>
        </Box>
      )}
      <Box width={iconCenter ? 0 : 1}>
        <Box
          bgcolor={debug ? 'lightyellow' : white}
          width={1}
          height={0.5}
          display="flex"
          justifyContent="left"
          alignItems="center"
          paddingY={2}
        >
          <Typography variant="h5" component="h2" color="secondary">
            {title}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
});

export default CardHeader;
